import { createNamespacedHelpers } from 'vuex'
import { CONFIG_MUTATIONS, CONFIG_GETTERS } from '../interface/config'
import { merge } from 'lodash'

export const Config = {
  ZCM: 'zcm',
  SDGS: 'sdgs',
}

const initState = {
  config: {
    origin: '',
  },
}

const mutations = {
  [CONFIG_MUTATIONS.SET_CONFIG](state, paylod) {
    state.config = merge(state.config, paylod)
  },
}

const getters = {
  [CONFIG_GETTERS.IS_ZCM_ORIGIN](state) {
    return state.config.origin === Config.ZCM
  },
  [CONFIG_GETTERS.IS_SDGS_ORIGIN](state) {
    return state.config.origin === Config.SDGS
  },
}

const { mapMutations, mapState, mapGetters } = createNamespacedHelpers('config')

export { mapMutations, mapState, mapGetters, CONFIG_MUTATIONS, CONFIG_GETTERS }

export default {
  namespaced: true,
  state: initState,
  mutations: mutations,
  getters: getters,
}
